import { render, staticRenderFns } from "./umedidas.vue?vue&type=template&id=12099022"
import script from "./umedidas.vue?vue&type=script&lang=js"
export * from "./umedidas.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports